import { render, staticRenderFns } from "./OFSlider.vue?vue&type=template&id=90f10564&"
import script from "./OFSlider.vue?vue&type=script&lang=js&"
export * from "./OFSlider.vue?vue&type=script&lang=js&"
import style0 from "./OFSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports